import {
  Alert,
  AlertTitle,
  alpha,
  Avatar,
  Box,
  Button,
  ButtonBase,
  Checkbox,
  Container,
  Grid,
  Grow,
  Link,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import TopBar from "../../../Components/TopBar/TopBar";
import MovieFilterOutlinedIcon from '@mui/icons-material/MovieFilterOutlined';
import Footer from "../../../Components/Footer/Footer";
import React, {useEffect} from "react";
import WordPullUp from "../../../Components/magicui/WordPullOut/WordPullOut";
import {logout, register} from "../../../services/auth.services";
import {browserDetection} from "../../../utils/browserDetection";
import {useAlert} from "../../../Components/Providers/Alert/Alert.provider";
import {osDetection} from "../../../utils/osDetection";
import {LoadingButton} from "@mui/lab";
import CookieOutlinedIcon from '@mui/icons-material/CookieOutlined';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import {getCookie, setCookie} from "../../../services/connectors/cookies";
import ReactGA from "react-ga4";
import {useTestStatus} from "../../../Components/Providers/TestStatus/TestStatus.provider";
import {pathFromStatus} from "../../../utils/testStatusUtils";
import {testStatus} from "../../../entities/testStatus";

const HomePage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const alerter = useAlert();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const {status, setStatus, testProgress, setTestProgress} = useTestStatus();
  const [loading, setLoading] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [cookies, setCookies] = React.useState(true);
  const [isUserRegistered, setIsUserRegistered] = React.useState(false);

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleTestStart = async () => {
    setLoading(true)
    const userData = {
      browser: browserDetection(),
      os: osDetection(),
      language: navigator.language,
    }
    await logout().then(() => {
      register(userData)
        .then(() => {
          setLoading(false)
          setCookie('test_status', testStatus.DEMOGRAPHIC, 1)
          navigate('/test/demographic');
        })
        .catch((err) => {
          setLoading(false)
          alerter.setAlertEvent({
            message: err.message,
            severity: "error"
          })
        })
    })
  }

  const handleBackToTest = () => {
    navigate(`/test/${pathFromStatus(status)}`)
  }

  const handleAcceptCookies = () => {
    setCookie('cookies', 'accepted', 1).then(() => {
    })
    setCookies(false)
  }

  useEffect(() => {
    if (getCookie('cookies')) {
      setCookies(false)
    }
    if (Number(getCookie('test_status')) === Number(testStatus.COMPLETED)) {
      logout().then(() => {
        navigate('/')
      })
      return;
    }
    if (getCookie('token') && getCookie('test_status')) {
      setIsUserRegistered(true)
    }
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search
    });
  }, [])

  return (
    <Box>
      <TopBar title="Rumors Research"/>
      <Container
        sx={{
          mt: isMobile ? 15 : 20,
          mb: isMobile ? 15 : 25
        }}
        maxWidth={isLargeScreen ? "xl" : "lg"}

      >
        <Grid container spacing={3} direction="column">
          <Grid item container spacing={2} alignItems="center">
            <Grid item>
              {
                !isMobile && <Avatar
                      sx={{
                        height: isMobile ? theme => theme.spacing(6) : theme => theme.spacing(10),
                        width: isMobile ? theme => theme.spacing(6) : theme => theme.spacing(10),
                        backgroundColor: alpha(theme.palette.primary.main, 0.2),
                      }}
                      variant="rounded"
                  >
                      <MovieFilterOutlinedIcon fontSize="large"/>
                  </Avatar>
              }
            </Grid>
            <Grid item>
              <WordPullUp words={"RUMORS RESEARCH"}/>
            </Grid>
          </Grid>
          <Grid item>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Welcome to Rumors Research! We are a research team from Roma Tre University's AI Research Lab. Our
              goal is to provide you with personalized movie recommendations based on your preferences.
            </Typography>
            <Typography variant="body1" color="textSecondary">
              How does it work?
            </Typography>
            <Typography variant="body1" color="textSecondary">
              1. Answer a few questions about your movie preferences.
            </Typography>
            <Typography variant="body1" color="textSecondary">
              2. Receive movie recommendations based on your preferences.
            </Typography>
            <Typography variant="body1" color="textSecondary">
              3. Provide feedback on the recommendations.
            </Typography>
          </Grid>
          <Grid item>
            <Alert
              severity="info"
            >
              <AlertTitle>
                Thank you for your interest in our research!
              </AlertTitle>
              Unfurtunately, the test is currently closed. Please come back later.
            </Alert>
          </Grid>
{/*          <Grid item container spacing={1} alignItems="center">
            <Grid item xs="auto">
              <Checkbox
                checked={checked}
                onChange={handleCheck}
                inputProps={{'aria-label': 'controlled'}}
              />
            </Grid>
            <Grid item xs>
              <ButtonBase onClick={() => setChecked(!checked)} disableRipple>
                <Typography variant="body2" color="textSecondary" align="left">
                  I agree to participate in this research and understand that my responses will be used for research
                  purposes only.
                </Typography>
              </ButtonBase>
            </Grid>
          </Grid>
          <Grid item>
            <LoadingButton
              color="primary"
              loading={loading}
              onClick={handleTestStart} disabled={!checked}
              sx={{
                backgroundColor: alpha(theme.palette.primary.main, 0.2),
                "&:hover": {
                  backgroundColor: alpha(theme.palette.primary.main, 0.25),
                },
              }}
            >
              <Box mx={2}>
                {isUserRegistered ? "restart" : "start"}
              </Box>
            </LoadingButton>
          </Grid>
          <Grow in={isUserRegistered} unmountOnExit mountOnEnter>
            <Grid item>
              <Alert
                severity="warning"
                action={!isMobile && <Button
                    sx={{px: 2, mt: '12px'}}
                    size="small"
                    color="inherit"
                    endIcon={<UndoOutlinedIcon/>}
                    onClick={handleBackToTest}>
                    Back&nbsp;to&nbsp;Test
                </Button>}
              >
                <AlertTitle>
                  Wait a minute!
                </AlertTitle>
                It seems you have already started the test. Want to go back?{" "}
                {isMobile && <Link
                    color="inherit"
                    onClick={handleBackToTest}>
                    Back&nbsp;to&nbsp;Test
                </Link>}
              </Alert>
            </Grid>
          </Grow>*/}
        </Grid>
      </Container>
      <Footer>
        <Grow in={cookies} unmountOnExit mountOnEnter>
          <Alert
            sx={{
              borderRadius: 0
            }}
            icon={<CookieOutlinedIcon fontSize="inherit"/>}
            severity="info"
            onClose={handleAcceptCookies}>
            This project is part of a research study conducted by Roma Tre University. If you have any questions,
            please contact us. This site uses cookies to improve your experience. By continuing to use this site, you
            agree to the use of cookies.
          </Alert>
        </Grow>
      </Footer>
    </Box>
  )
}

export default HomePage;